import { CasinoGame } from '@/types/casino';

interface Props {
  game: CasinoGame;
  onClick?: (game: CasinoGame) => void;
}

export default function CasinoGameCard({ game, onClick }: Props) {
  return (
    <button
      onClick={() => onClick?.(game)}
      className="group relative aspect-square w-full overflow-hidden rounded-xl animate-fade-in"
    >
      <img
        src={game.gameImage}
        alt={game.name}
        className="
          h-full
          w-full
          object-cover
          object-center
          transition-transform
          duration-300
          group-hover:scale-105
        "
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = '/images/casino-card-placeholder.webp';
        }}
      />
    </button>
  );
}
